var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrap_footer" },
    [
      _c("el-pagination", {
        attrs: {
          background: "",
          "current-page": _vm.currentPage,
          "page-sizes": _vm.$pageListDefaultNew,
          "page-size": _vm.maxPageItem,
          layout: _vm.$pageLayoutDefault,
          total: _vm.totalElements,
        },
        on: {
          "size-change": _vm.handleChangeSize,
          "current-change": _vm.handleChangePage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }